export enum SalesCreditMiniForm {
  Refund = 'REFUND',
}

export const SALES_CREDIT_DOCUMENT_STATUS = [
  {
    key: 'vatInclusive',
    status: [
      {
        value: true,
        style: 'info',
        title: 'VAT INCLUSIVE',
      },
    ],
  },
  {
    key: 'documentStatus',
    status: [
      { value: 'DRAFT', style: 'default' },
      { value: 'POSTED', icon: 'check_circle', style: 'success' },
      { value: 'CREDITED', icon: 'error_outline', style: 'warning' },
      { value: 'RELEASED', icon: 'watch_later', style: 'warning' },
    ],
  },
  {
    key: 'foreignCurrency',
    status: [
      {
        value: true,
        style: 'info',
        icon: 'account_balance',
        title: '',
        titleKey: 'currency.isoCode.codeAlpha3',
      },
    ],
  },
  {
    key: 'salesCreditType',
    status: [
      {
        value: 'RETURN',
        style: 'default',
      },
      {
        value: 'REFUND',
        style: 'default',
      },
    ],
  },
];
